import * as z from "zod/v4";
import { ProfileSchema } from "./profile.js";

const ListProfilesResponseSchema_ = z.object({
  profiles: z.array(ProfileSchema),
});
export const ListProfilesResponseSchema: z.ZodType<ListProfilesResponse> =
  ListProfilesResponseSchema_;
export interface ListProfilesResponse
  extends z.infer<typeof ListProfilesResponseSchema_> {}
